import React from 'react';

import {} from 'react-bootstrap';
import './code.css'

export default function ( props ){
    return(
        <div className='code'>
           <p> { props.code }</p>
        </div>
    )
}